import * as Yup from 'yup';
export const initialRegisterValues = {
    username: '',
    password: '',
    token: '',
    acceptedTerms: false,
};
export const initialLoginValues = {
    email: '',
    password: '',
};
export const initialForgotPasswordValues = {
    email: '',
};
export const initialResetPasswordValues = {
    username: '',
    password: '',
    resetToken: '',
};
export const registerSchema = Yup.object().shape({
    username: Yup.string().email().required(),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(/^(?=.*[A-Z])(?=.*[0-9])/, 'Password must contain at least 1 capital letter and 1 number')
        .required('Password is required'),
    acceptedTerms: Yup.bool().required(),
});
export const loginSchema = Yup.object().shape({
    email: Yup.string().required(),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(/^(?=.*[A-Z])(?=.*[0-9])/, 'Password must contain at least 1 capital letter and 1 number')
        .required('Password is required'),
});
export const resetSchema = Yup.object().shape({
    email: Yup.string().email().required('Email is required'),
});
export const resetPasswordSchema = Yup.object().shape({
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(/^(?=.*[A-Z])(?=.*[0-9])/, 'Password must contain at least 1 capital letter and 1 number')
        .required('Password is required'),
});
//# sourceMappingURL=login-request.js.map